import React, {useState, useEffect, useRef} from 'react';
import Link from 'next/link';
import throttle from 'lodash.throttle'; // Add lodash throttle for better performance

const wrapperRef = React.createRef();

function DesktopNavComponent(props) {
	const {styles} = props;
	const [activeMenu, setActiveMenu] = useState('');
	const [show, setShow] = useState(false);
	const lastScroll = useRef(0);

	const controlNavbar = throttle(() => {
		if (window.scrollY > lastScroll.current) {
			setShow(true); // Navbar is hidden when scrolling down
		} else {
			setShow(false); // Navbar is shown when scrolling up
		}
		lastScroll.current = window.scrollY;
	}, 200); // Throttle the function to run every 200ms

	useEffect(() => {
		window.addEventListener('scroll', controlNavbar);
		return () => {
			window.removeEventListener('scroll', controlNavbar);
		};
	}, []);

	useEffect(() => {
		const outSideModalClickEvent = event => {
			if (wrapperRef && !wrapperRef.current?.contains(event.target)) {
				setActiveMenu('');
			}
		};

		const removeListener = () => {
			document.removeEventListener('mousedown', outSideModalClickEvent);
		};
		document.addEventListener('mousedown', outSideModalClickEvent);
		return () => {
			removeListener();
		};
	}, []);

	const changeActiveMenu = _id => {
		if (activeMenu === _id) setActiveMenu('');
		else setActiveMenu(_id);
	};

	return (
		<div
			className={`${styles.menuOuter} ${show && styles.navigationHidden}`}
			ref={wrapperRef}
		>
			<div className={styles.navigation}>
				<ul className='d-flex'>
					<li onClick={() => changeActiveMenu('')}>
						<Link href={`/`}>Home</Link>
					</li>
					<li onClick={() => changeActiveMenu('')}>
						<Link href={`/drop-auctions/all`}>Upcoming Auctions</Link>
					</li>
					{/*<li onClick={() => changeActiveMenu('')}>*/}
					{/*	<Link href={`/retailers`}>Sell With Us</Link>*/}
					{/*</li>*/}
					<li onClick={() => changeActiveMenu('')}>
						<Link href={`/contact`}>Contact</Link>
					</li>
				</ul>
			</div>
		</div>
	);
}

export default DesktopNavComponent;
